export * from './dlg-decoration.module';
